import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

const FULLSCREEN_OVERLAY_CLASS =
  'fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-4 bg-background/80 backdrop-blur-sm';
const SCOPED_OVERLAY_CLASS =
  'absolute inset-0 z-10 flex flex-col items-center justify-center gap-3 rounded-[inherit] bg-background/85 backdrop-blur-sm';
const FULLSCREEN_SVG_CLASS = 'w-36 max-w-[70vw]';
const SCOPED_SVG_CLASS = 'w-20 max-w-[60%]';

@Component({
  selector: 'k-loader',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: 'k-loader.component.html',
})
export class KLoaderComponent {
  //* Services
  public readonly loader = inject(LoaderService);

  //* Signals
  public readonly loading = input<boolean | null>(null);
  public readonly message = input<string | null>(null);
  public readonly fullscreen = input<boolean>(true);

  //* Computed
  public readonly isVisible = computed<boolean>(() => this.loading() ?? this.loader.isLoading());

  public readonly displayMessage = computed<string | null>(
    () => this.message() ?? this.loader.message(),
  );

  public readonly overlayClass = computed<string>(() =>
    this.fullscreen() ? FULLSCREEN_OVERLAY_CLASS : SCOPED_OVERLAY_CLASS,
  );

  public readonly svgClass = computed<string>(() =>
    this.fullscreen() ? FULLSCREEN_SVG_CLASS : SCOPED_SVG_CLASS,
  );
}
